import { Labels } from "@cloudserver/contracts";

/** Labels as the text a person edits: one `key=value` per line. */
export const formatLabels = (labels: Record<string, string>): string =>
  Object.entries(labels)
    .map(([k, v]) => (v ? `${k}=${v}` : k))
    .join("\n");

/**
 * Reads `key=value` lines (a bare `key` means an empty value); blank lines
 * are skipped. Returns the first invalid line (1-based) instead of labels
 * when one does not follow the provider's rules.
 */
export function parseLabels(
  text: string,
): { labels: Record<string, string>; badLine: null } | { labels: null; badLine: number } {
  const labels: Record<string, string> = {};
  const lines = text.split("\n");
  for (const [index, raw] of lines.entries()) {
    const line = raw.trim();
    if (!line) continue;
    const eq = line.indexOf("=");
    const key = (eq === -1 ? line : line.slice(0, eq)).trim();
    const value = eq === -1 ? "" : line.slice(eq + 1).trim();
    if (!Labels.safeParse({ [key]: value }).success) return { labels: null, badLine: index + 1 };
    labels[key] = value;
  }
  return { labels, badLine: null };
}
